var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useEffect, useState } from 'react';
import { useOrdersAsync } from '../../../..';
import { useAPIContext, useStoreContext } from '../../../../components/Context';
import { useCallbackRef } from '../../../../utils';
import { submitAttempt } from '../../draft/actions';
import { createAsyncState } from '../hooks';
import { getOrdersState } from '../orders-search/selectors';
import { toDraftBody, toOrder } from './selectors';
var useDraftAsync = createAsyncState('draft');
export var useSubmitRequest = function () {
    var _a = useAPIContext(), draft = _a.draft, commit = _a.commit;
    var _b = useDraftAsync(), asyncState = _b[0], _c = _b[1], reset = _c.reset, start = _c.start, success = _c.success, error = _c.error;
    var _d = useOrdersAsync(), orderSuccess = _d[1].success;
    var _e = useStoreContext(), state = _e[0], dispatch = _e[1];
    var _f = useState(), body = _f[0], setBody = _f[1];
    var submitHandler = useCallbackRef(function () {
        var validate = state.validate, values = state.draft.values;
        // валидируем черновик
        var errors = validate(values, state);
        // сохраняем ошибки в стейте
        dispatch(submitAttempt({
            errors: errors,
        }));
        // если ошибки есть, ничего не делаем
        if (errors) {
            return;
        }
        setBody(toDraftBody(state));
    });
    var successHandler = useCallbackRef(function (body) { return function (response) {
        var _a;
        var orders = ((_a = getOrdersState(state).data) === null || _a === void 0 ? void 0 : _a.orders) || [];
        var order = toOrder(body, response);
        success(response);
        // добавляем новый заказ в список заказов,
        // так как заказ имеет активный статус, но начинается поллинг, см. orders-search/hooks
        orderSuccess({
            orders: __spreadArray([order], orders),
        });
    }; });
    useEffect(function () {
        if (draft && commit && body) {
            start();
            // сначала draft
            var cancelCreate_1 = draft({
                body: body,
                onSuccess: function (draftResponse) {
                    // потом commit
                    cancelCreate_1 = commit({
                        body: {
                            orderid: draftResponse.orderid,
                        },
                        onSuccess: successHandler(body),
                        onError: error,
                    });
                },
                onError: error,
            });
            return function () { return cancelCreate_1(); };
        }
    }, [body, commit, draft, error, start, successHandler]);
    useEffect(function () { return reset; }, [reset]);
    return [submitHandler, asyncState];
};
